export const AnalyticsPromoteSrc = 76;
export const AnalyticsPromoteEndpoint = 'pa';
export const ElementsClick = 1113;
export const AnalyticsClicksCollapsibleTextExpandActionName = 'Expand';
export const AnalyticsClicksCollapsibleTextUDPExpandActionName = 'Expand';
//# sourceMappingURL=consts.js.map